import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { Text } from '@/components/common/text';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';

export const PaymentMethodCardHeader: React.FC<{ cardType: { name: string; icon: React.ReactNode; isBank: boolean } | null; last4?: string; isOnlyCard?: boolean; }> = ({ cardType, last4, isOnlyCard }) => {
  const last4Prefix = isOnlyCard ? '**** **** **** ' : '*';
  return (
    <View style={styles.cardHeader}>
      {cardType && cardType.icon && (
        <View style={styles.cardBrandContainer}>
          {cardType.icon}
        </View>
      )}
      {cardType?.isBank && last4 && (
        <Text style={styles.cardNumber}>
          {last4Prefix}{last4}
        </Text>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  cardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  cardBrandContainer: {
    width: '25%',
    aspectRatio: 1.6,
  },
  cardNumber: {
    fontSize: 14,
    fontWeight: '400',
  },
});

export default PaymentMethodCardHeader;


